"use strict";

var _interopRequireDefault = require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));
var _defineProperty2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _objectSpread3 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _FormFactory = _interopRequireDefault(require("../FormFactory"));
var _excluded = ["schema", "object", "onSave", "onBack", "findObject", "saveObject", "saveImage", "saveFile", "schemas"];
var _jsxFileName = "/home/cej/Documents/VS_Code/MWeeB/nq-component/src/FormDialog/index.js";
function FormDialog(_ref) {
  var schema = _ref.schema,
    object = _ref.object,
    onSave = _ref.onSave,
    onBack = _ref.onBack,
    findObject = _ref.findObject,
    saveObject = _ref.saveObject,
    saveImage = _ref.saveImage,
    saveFile = _ref.saveFile,
    schemas = _ref.schemas,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _React$useState = _react["default"].useState({}),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    change = _React$useState2[0],
    setChange = _React$useState2[1];
  function onChange(value, field) {
    setChange((0, _objectSpread3["default"])((0, _objectSpread3["default"])({}, change), {}, (0, _defineProperty2["default"])({}, field, value)));
  }
  function onSubmit(_x) {
    return _onSubmit.apply(this, arguments);
  }
  function _onSubmit() {
    _onSubmit = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(e) {
      var _object;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            _context.prev = 1;
            _context.next = 4;
            return saveObject.execute(schema.collection, change);
          case 4:
            _object = _context.sent;
            onSave(_object);
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            console.error("FAILED SEND", _context.t0);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 8]]);
    }));
    return _onSubmit.apply(this, arguments);
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-4 px-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "fw-bold",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 13
    }
  }, "Create ", schema.label || schema.collection), /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: onSubmit,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row g-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react["default"].createElement(_FormFactory["default"], Object.assign({
    className: "col-md-6",
    schema: schema,
    object: object,
    onChange: onChange,
    findObject: findObject,
    saveObject: saveObject,
    saveFile: saveFile,
    saveImage: saveImage,
    schemas: schemas
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 21
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-end mt-3",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 17
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "submit",
    className: "btn btn-primary btn-sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 21
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "bi bi-plus me-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 25
    }
  }), "SAVE AND ASSOCIATE"), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-outline-primary btn-sm ms-2",
    onClick: onBack,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 21
    }
  }, "GO BACK"))));
}
var _default = exports["default"] = FormDialog;